import React, {useEffect, useMemo} from 'react';
import ReactWebChat, {createDirectLine, createStyleSet} from 'botframework-webchat';
import './WebChat.css';

const WebChat = ({className, onFetchToken, store, token}) => {
    const directLine = useMemo(() => {
        try {
            return createDirectLine({
                token,
                webSockets: true,
                watermark: 10
            });
        } catch (e) {
            sessionStorage['token'] && sessionStorage.removeItem("token");
            sessionStorage['conversation_Id'] && sessionStorage.removeItem("conversation_Id");
            return createDirectLine({
                token,
                webSockets: true,
                watermark: 10
            });
        }
    }, [token]);

    const styleSet = useMemo(
        () => {
            const styleSet = createStyleSet({
                backgroundColor: 'Transparent',
                sendBoxTextWrap: true,
                fontSizeSmall: '60%',
                emojiSet: true,
                accent: '#444',
            });
            styleSet.textContent = {
                ...styleSet.textContent,
                fontFamily: "Arial, sans-serif",
            };
            return styleSet;
        },
        []
    );

    useEffect(() => {
        try {
            onFetchToken();
        } catch (e) {
            sessionStorage['token'] && sessionStorage.removeItem("token");
            sessionStorage['conversation_Id'] && sessionStorage.removeItem("conversation_Id");
            onFetchToken();
        }
    }, [onFetchToken]);

    window.addEventListener('error', function (e) {
        console.log("our:", e)
        if (e?.message?.includes("ajax error 403")) {
            sessionStorage['token'] && sessionStorage.removeItem("token");
            sessionStorage['conversation_Id'] && sessionStorage.removeItem("conversation_Id");
        }
    });

    return token ? (
        <>
            <ReactWebChat className={`${className || ''} web-chat`}
                          directLine={directLine}
                          store={store}
                          styleSet={styleSet}/>
        </>
    ) : (
        <div className={`${className || ''} connect-spinner`}>
            <div className="content">
                <div className="icon">
                    <span className="ms-Icon ms-Icon--CloudSecure"/>
                </div>
                <p>Please wait while we are connecting.</p>
            </div>
        </div>
    );
};

export default WebChat;
